import React from 'react'

import type { AnalyticsRowsProps } from '@fourthwall/module-analytics'
import { DataLabel } from '@fourthwall/module-analytics'
import { pluralize } from '@fourthwall/utils/dist/string'

import type { ConversionRatesAggregatedValue } from '../AnalyticsOverview.types'

export const mapConversionRatesAggregatedValueToAnalyticsRows = (
  data: ConversionRatesAggregatedValue,
): AnalyticsRowsProps['rows'] => {
  if (!data) return []

  const getDescription = (value: number) => `${value} ${pluralize(value, 'session')}`

  return [
    {
      label: (
        <DataLabel label="Added to cart" description={getDescription(data.cartCreated.value)} />
      ),
      value: `${data.cartCreated.percentage}%`,
    },
    {
      label: (
        <DataLabel
          label="Checkout started"
          description={getDescription(data.checkoutCreated.value)}
        />
      ),
      value: `${data.checkoutCreated.percentage}%`,
    },
    {
      label: (
        <DataLabel
          label="Successful checkout"
          description={getDescription(data.checkoutPaid.value)}
        />
      ),
      value: `${data.checkoutPaid.percentage}%`,
    },
  ]
}
